import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { useLang } from '../../context/LanguageContext';
import { useEnquiryReview } from '../../hooks/useEnquiryReview';
import { reviewCopy } from '../../data/review-copy';
import { ReviewSource } from './review/ReviewSource';
import { ReviewSummary } from './review/ReviewSummary';
import { ReviewEditor } from './review/ReviewEditor';
import { ReviewControls, ReviewConfirmation } from './review/ReviewControls';

const ReviewAssistance = ({ state, confirmation, onGenerate, copy }) => <div className="review-assistance">
  <ReviewControls state={state} confirmation={confirmation} onGenerate={onGenerate} copy={copy} />
  {['loading', 'generating'].includes(state.status) && <p className="loading-line" data-testid="review-loading">{copy.loading}</p>}
  {state.error && <p role="alert" className="error-message" data-testid="review-error">{state.error === 'load' ? copy.loadError : state.error}</p>}
  {!state.review && state.status === 'idle' && <p className="review-empty muted" data-testid="review-empty">{copy.empty}</p>}
  {state.review && <div className="review-results"><ReviewSummary review={state.review} copy={copy} /><ReviewEditor state={state} copy={copy} /></div>}
</div>;

export const EnquiryReviewPanel = ({ record, onClose }) => {
  const { lang } = useLang();
  const copy = reviewCopy[lang];
  const state = useEnquiryReview(record, lang);
  const [confirmation, setConfirmation] = useState(null);
  const generate = () => { setConfirmation(null); state.generate(); };
  const requestGeneration = () => state.review ? setConfirmation('regenerate') : generate();
  const requestClose = () => state.dirty ? setConfirmation('discard') : onClose();
  return <Dialog open onOpenChange={open => { if (!open) requestClose(); }}><DialogContent className="review-dialog" data-testid="enquiry-review-dialog">
    <DialogHeader><DialogTitle data-testid="review-record-title">{record.title || copy.title}</DialogTitle><DialogDescription data-testid="review-safety-note">{copy.notice}</DialogDescription></DialogHeader>
    {confirmation && <ReviewConfirmation action={confirmation} onCancel={() => setConfirmation(null)} onConfirm={confirmation === 'regenerate' ? generate : onClose} copy={copy} />}
    <div className="review-layout"><ReviewSource record={record} messages={state.messages} copy={copy} /><ReviewAssistance state={state} confirmation={confirmation} onGenerate={requestGeneration} copy={copy} /></div>
  </DialogContent></Dialog>;
};